import BookShow from "components/shared/book/show";
import { FilesField } from "components/shared/form";
import { viewContainer } from "helpers/redux";
import React from "react";
import { uploadFile } from "sources/books/news";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowNews extends BookShow {
    get dropdActions() {
        return [{ text: "Удалить", action: this.actionClose }];
    }

    renderFiles = () => (
        <FilesField
            withoutDownload
            modal={this.props.modal}
            uploadFile={uploadFile}
            files={this.state.data.files}
            onChange={(files) =>
                this.setState({
                    shouldUpdate: true,
                    data: { ...this.state.data, files, fileIds: files.map((file) => file.id) },
                })
            }
        />
    );

    renderBody = () => {
        const { config } = this.props;
        return (
            <Markup
                {...config}
                renderField={this.renderField}
                renderFiles={this.renderFiles}
                editorValue={this.state.data.text}
                onChange={this.setValue}
                Button={this.renderButton}
            />
        );
    };
}

const ConfiguredShow = (props) => <ShowNews {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "news");
